import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const OvenCleaningPage = () => {
  const pageData = {
    pageTitle: "Oven Cleaning Cardiff | Professional Oven Cleaners | NeatWave",
    metaDescription: "Professional oven cleaning in Cardiff, Barry and Penarth. Single, double and range ovens, hobs and extractors cleaned with low-fume products. From £50. Request a free quote.",
    quoteService: "Oven Cleaning",
    heroImageAlt: "Before and after professional oven clean in Cardiff",
    
    heroTitle: "Professional Oven Cleaning in Cardiff",
    heroSubtitle: "Specialist oven cleaning that restores your oven to showroom condition. Safe, eco-friendly, and effective deep clean service.",
    heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/4a11c64a7fad14ac_5ee0252bbf3148096cd43c20986115e03eaa88383588dcb96d6033a249095406.webp",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Your oven works hard - let us restore it to sparkling condition. Our specialist oven cleaning service in Cardiff uses professional techniques and eco-friendly products to remove built-up grease, carbon, and grime without harsh chemicals or strong fumes.
        </p>
        <p className="mb-4">
          Whether it's a standard domestic oven, range cooker, or AGA, our experienced technicians have the expertise and equipment to achieve outstanding results. We clean ovens, hobs, extractors, and microwaves throughout Cardiff, Barry and Penarth.
        </p>
        <p className="mb-4">
          Perfect as a standalone service or add-on to our regular, deep, or end of tenancy cleaning. Regular oven cleaning (every 3-6 months) improves efficiency, eliminates smoke, and extends your appliance's lifespan.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Oven Interior",
        description: "Deep clean inside oven cavity, remove carbon build-up, degrease walls and ceiling"
      },
      {
        title: "Racks & Trays",
        description: "Strip and clean all racks, trays, grill pans in professional solution"
      },
      {
        title: "Oven Door",
        description: "Clean between glass panels, polish exterior, restore shine to door"
      },
      {
        title: "Hob & Burners",
        description: "Clean hob surface, burners, grates, control knobs, remove grease"
      },
      {
        title: "Extractor Hood",
        description: "Clean exterior, filters, remove grease build-up (basic service included)"
      },
      {
        title: "Final Polish",
        description: "Polish exterior surfaces, ensure all areas are spotless and shine restored"
      }
    ],
    
    pricingInfo: {
      duration: "1-2 hours",
      price: "From £50",
      note: "Standard single oven from £50. Double ovens, range cookers, and AGAs priced on inspection. Heavily soiled ovens may require additional time. Add-on discount available with other cleaning services."
    },
    
    faqs: [
      {
        q: "How often should I have my oven professionally cleaned?",
        a: "We recommend professional oven cleaning every 3-6 months depending on usage. If you cook frequently, quarterly cleaning maintains optimal performance and prevents heavy carbon build-up. Light users may only need it twice a year."
      },
      {
        q: "Is oven cleaning safe for my appliance?",
        a: "Absolutely. We use professional, eco-friendly cleaning products specifically designed for oven cleaning. Our technicians are trained to clean safely without damaging seals, elements, or finishes. We've cleaned hundreds of ovens across Cardiff without incident."
      },
      {
        q: "How long does oven cleaning take?",
        a: "A standard single oven typically takes 1-1.5 hours. Double ovens or range cookers take 1.5-2 hours. We'll give you an accurate time estimate when you book. You can use your oven immediately after cleaning - no drying time needed."
      },
      {
        q: "Can you clean really dirty, neglected ovens?",
        a: "Yes! Even heavily neglected ovens can be restored. While very dirty ovens may take slightly longer and might not return to 'like new' condition if damage has occurred, we can usually achieve excellent results. We'll advise honestly about what's achievable."
      },
      {
        q: "Do you clean other kitchen appliances?",
        a: "Yes, we can clean microwaves, extractor hoods, hobs, and other appliances. These can be added to your oven clean for a discounted rate. Just ask when booking about additional appliances you'd like cleaned."
      }
    ],
    
    testimonial: {
      text: "We had Neatwave carry out all of our end of tenancy cleans when our student tenancies swapped over, they completed around 60 oven cleans for us and they were fab, very professional and reasonably priced, would definitely recommend.",
      author: "Charlie Redding, Pinnacle Property Management - Google review"
    },
    
    relatedServices: [
      {
        title: "Deep Cleaning",
        description: "Add oven clean to your full home deep clean",
        url: "/deep-cleaning-cardiff"
      },
      {
        title: "End of Tenancy Cleaning",
        description: "Include oven clean for deposit return",
        url: "/end-of-tenancy-cleaning-cardiff"
      },
      {
        title: "Regular Domestic Cleaning",
        description: "Combine with regular cleaning service",
        url: "/domestic-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default OvenCleaningPage;